module.exports = __webpack_public_path__ + "static/media/img_panel_REITs.507e100c.jpg";